import 'zone.js';
import 'hammerjs';